import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { AppService } from '../../../app.service';
import { Observable } from 'rxjs';


interface MoveCtoRequest {
    pid: string;
    olt_id: string;
    olt_slot: number;
    olt_port: number;
}

@Injectable({
    providedIn: 'root'
})
export class NetworkService {

    appData: any;

    constructor(
        private httpClient: HttpClient,
        private appService: AppService,
    ) {
        this.appData = appService.settings;
    }

    getEventLog(iua: string): Observable<any> {
        const params = new HttpParams().append('idAdministrative', iua);
        return this.httpClient.get<any>(`${this.appData.webApi}/network/getEventLog`, { params });
    }

    retry(iua: string, eventName: string): Observable<any> {
        const params = new HttpParams().append('idAdministrative', iua).append('eventName', eventName);
        return this.httpClient.post<any>(`${this.appData.webApi}/network/retry`, {}, { params });
    }

    moveCto(pid: string, olt_id: string,
        olt_slot: number, olt_port: number): Observable<any> {
        const body: MoveCtoRequest = {
            pid: pid,
            olt_id: olt_id,
            olt_slot: Number(olt_slot),
            olt_port: Number(olt_port)
        };

        return this.httpClient.post<any>(`${this.appData.webApi}/network/moveCto`, body);
    }

}